<template>
  <path
    d="M18 13.0002H6C5.45 13.0002 5 12.5502 5 12.0002C5 11.4502 5.45 11.0002 6 11.0002H18C18.55 11.0002 19 11.4502 19 12.0002C19 12.5502 18.55 13.0002 18 13.0002Z"
  />
</template>
